module.exports = __webpack_public_path__ + "img/CRP LATEX.2(mid).b52b6fca.jpg";